export enum FeatureType {
    RolesRightsView = 'Roles/Rights - View',
    RolesRightsEdit = 'Roles/Rights - Edit',

    UsersView = 'Users - View',
    UsersEdit = 'Users - Edit',

    BidAnalyticsView = 'Bid Analytics - View',
    BidAnalyticsEdit = 'Bid Analytics - Edit',

    BidFabShopStockProductsView = 'Bids - Fab Shop Stock Products - View',

    BidViewpointDataView = 'Bids - Viewpoint Data - View',

    BidRateDataView = 'Bids - Bid Rate Data - View',

    EquipmentFuelEntryEdit = 'Equipment - Fuel Entry - Edit',

    EquipmentFuelRecordsView = 'Equipment - Fuel Records - View',
    EquipmentFuelRecordsEdit = 'Equipment - Fuel Records - Edit',

    EquipmentAvailabilityView = 'Equipment - Availability - View',
    EquipmentAvailabilityEdit = 'Equipment - Availability - Edit',

    EquipmentSubCategoryPriorityView = 'Equipment - Sub-Category Priority - View',
    EquipmentSubCategoryPriorityEdit = 'Equipment - Sub-Category Priority - Edit',
    EquipmentTireManagementView = 'Equipment - Tire Management - View',
    EquipmentTireManagementEdit = 'Equipment - Tire Management - Edit',

    EquipmentPartsFluidsView = 'Equipment - Parts & Fluids - View',
    EquipmentPartsFluidsEdit = 'Equipment - Parts & Fluids - Edit',

    EquipmentWorkOrdersView = 'Equipment - Work Orders - View',
    EquipmentWorkOrdersEdit = 'Equipment - Work Orders - Edit',

    OperationsRentalsView = 'Operations - Rentals - View',
    OperationsRentalsEdit = 'Operations - Rentals - Edit',

    OperationsMaterialsView = 'Operations - Materials - View',
    OperationsMaterialsEdit = 'Operations - Materials - Edit',

    OperationsSchedulingView = 'Operations - Scheduling - View',
    OperationsSchedulingEdit = 'Operations - Scheduling - Edit',

    OperationsProjectionsView = 'Operations - Projections - View',

    ProjectManagementProductivityView = 'Project Management - Productivity - View',
    ProjectManagementProductivityEdit = 'Project Management - Productivity - Edit',

    OperationsBonusTableViewEdit = 'Operations - Bonus Table - View/Edit',

    HrSafetyView = 'HR - Safety - View',
    HrSafetyEdit = 'HR - Safety - Edit',

    HrRetentionView = 'HR - Retention - View',
    HrRetentionEdit = 'HR - Retention - Edit',

    HrScorecardGoalsView = 'HR - Scorecard - Goals - View',
    HrScorecardGoalsEdit = 'HR - Scorecard - Goals - Edit',

    HrScorecardHiringView = 'HR - Scorecard - Hiring - View',
    HrScorecardHiringEdit = 'HR - Scorecard - Hiring - Edit',

    HrScorecardAdminView = 'HR - Scorecard - Admin - View',
    HrScorecardAdminEdit = 'HR - Scorecard - Admin - Edit',

    HrAccountabilityChartView = 'HR - Accountability Chart - View',

    HrNotificationView = 'HR - Notification - View',
    HrNotificationEdit = 'HR - Notification - Edit',

    HrGroupsView = 'HR - Groups - View',
    HrGroupsEdit = 'HR - Groups - Edit',

    HrDisciplinaryActionView = 'HR - Disciplinary Action - View',
    HrDisciplinaryActionEdit = 'HR - Disciplinary Action - Edit',

    OperationsJobOwnershipTemplatesView = 'Operations - Job Ownership Templates - View',
    OperationsJobOwnershipTemplatesEdit = 'Operations - Job Ownership Templates - Edit',

    OperationsJobOwnershipsView = 'Operations - Job Ownerships - View',
    OperationsJobOwnershipsEdit = 'Operations - Job Ownerships - Edit',

    OperationsLeadershipTeamVisitsView = 'Operations - Leadership Team Visits - View',
    OperationsLeadershipTeamVisitsEdit = 'Operations - Leadership Team Visits - Edit',
    OperationsLeadershipTeamVisitsDashboardView = 'Operations - Leadership Team Visits Dashboard - View',

    OperationsManpowerOutliersView = 'Operations - Manpower Outliers - View',
    OperationsManpowerOutliersEdit = 'Operations - Manpower Outliers - Edit',

    ToolRoomTransfers = 'Tool Room - Transfers',
    ToolRoomRecordsView = 'Tool Room - Records - View',
    ToolRoomRecordsEdit = 'Tool Room - Records - Edit',

    ToolRoomEmployeeAssetsView = 'Tool Room - Employee Assets - View',

    SafetyMeetingView = 'Safety - Meeting - View',
    SafetyMeetingEdit = 'Safety - Meeting - Edit',

    SafetyDashboardView = 'Safety - Dashboard - View',

    SafetyJobHazardAnalysisView = 'Safety - Job Hazard Analysis - View',
    SafetyJobHazardAnalysisEdit = 'Safety - Job Hazard Analysis - Edit',
    SafetyJobHazardAnalysisDashboardView = 'Safety - Job Hazard Analysis Dashboard - View',

    SubcontractorTrainingView = 'Safety - Subcontractor Training - View',
    SubcontractorTrainingEdit = 'Safety - Subcontractor Training - Edit',

    SafetyVehicleInspectionView = 'Safety - Vehicle Inspection - View',
    SafetyVehicleInspectionEdit = 'Safety - Vehicle Inspection - Edit',
    SafetyVehicleInspectionDashboardView = 'Safety - Vehicle Inspection Dashboard - View',

    SafetyFeedbackView = 'Safety - Safety Feedback - View',
    SafetyFeedbackEdit = 'Safety - Safety Feedback - Edit',

    SafetyAutoAccidentReportView = 'Safety - Auto Accident Report - View',
    SafetyAutoAccidentReportEdit = 'Safety - Auto Accident Report - Edit',
    SafetyAutoAccidentReportDashboardView = 'Safety - Auto Accident Report Dashboard - View',

    SafetyIncidentInvestigationView = 'Safety - Incident Investigation - View',
    SafetyIncidentInvestigationEdit = 'Safety - Incident Investigation - Edit',
    SafetyIncidentInvestigationDashboardView = 'Safety - Incident Investigation Dashboard - View',

    SafetyChecklistView = 'Safety - Safety Checklist - View',
    SafetyChecklistEdit = 'Safety - Safety Checklist - Edit',
    SafetyChecklistDashboardView = 'Safety - Safety Checklist Dashboard - View',

    OperationsWipReportView = 'Operations - WIP Report - View',

    OperationsPmJcaReportView = 'Operations - PM JCA Report - View',
    EquipmentReportView = 'Equipment - Equipment Report - View',

    MeetingsMeetingView = 'Meetings - Meeting - View',
    MeetingsMeetingEdit = 'Meetings - Meeting - Edit',
    MeetingsMeetingAdmin = 'Meetings - Meeting - Admin',

    MeetingsBusinessPlanView = 'Meetings - Business Plan - View',
    MeetingsBusinessPlanEdit = 'Meetings - Business Plan - Edit',

    FieldToolsPlansAndSpecsView = 'Field Tools - Plans and Specs - View',
    FieldToolsPlansAndSpecsEdit = 'Field Tools - Plans and Specs - Edit',

    FieldToolsPendingChangeOrdersView = 'Field Tools - Pending Change Orders - View',
    FieldToolsPendingChangeOrdersEdit = 'Field Tools - Pending Change Orders - Edit',

    FieldToolsSiteConditionChangeView = 'Field Tools - Site Condition Change - View',
    FieldToolsSiteConditionChangeEdit = 'Field Tools - Site Condition Change - Edit',

    ProjectManagementPendingChangeOrdersView = 'Project Management - Pending Change Orders - View',
    ProjectManagementPendingChangeOrdersEdit = 'Project Management - Pending Change Orders - Edit',

    FieldToolsPoConfigView = 'Field Tools - PO Config - View',
    FieldToolsPoConfigEdit = 'Field Tools - PO Config - Edit',

    FieldToolsEquipmentReportView = 'Field Tools - Equipment Report - View',
    FieldToolsEquipmentReportEdit = 'Field Tools - Equipment Report - Edit',

    FieldToolsBlueStakesLogView = 'Field Tools - Blue Stakes Log - View',
    FieldToolsBlueStakesLogEdit = 'Field Tools - Blue Stakes Log - Edit',

    FieldToolsDamagedUtilityLogView = 'Field Tools - Damaged Utility Log - View',
    FieldToolsDamagedUtilityLogEdit = 'Field Tools - Damaged Utility Log - Edit',
    FieldToolsDamagedUtilityLogDashboardView = 'Field Tools - Damaged Utility Log Dashboard - View',

    FieldToolsPunchListView = 'Field Tools - Punch List - View',
    FieldToolsPunchListEdit = 'Field Tools - Punch List - Edit',

    FieldToolsForemanScheduleView = 'Field Tools - Foreman Schedule - View',
    FieldToolsForemanScheduleEdit = 'Field Tools - Foreman Schedule - Edit',
    FieldToolsForemanRosterEdit = 'Field Tools - Foreman Roster - Edit',

    AdminPlansView = 'Admin - Plans - View',
    AdminPlansEdit = 'Admin - Plans - Edit',

    AdminDivisionsView = 'Admin - Divisions - View',
    AdminDivisionsEdit = 'Admin - Divisions - Edit',

    AdminVistaUploadsView = 'Admin - Vista Uploads - View',
    AdminVistaUploadsDashboardView = 'Admin - Vista Uploads Dashboard - View',

    PurchasingDashboardView = 'Purchasing - Dashboard - View',

    PurchasingPurchaseOrdersView = 'Purchasing - Purchase Orders - View',
    PurchasingPurchaseOrdersEdit = 'Purchasing - Purchase Orders - Edit',

    PurchasingReceivingView = 'Purchasing - Receiving - View',
    PurchasingReceivingEdit = 'Purchasing - Receiving - Edit',

    PurchasingInvoicingView = 'Purchasing - Invoicing - View',
    PurchasingInvoicingEdit = 'Purchasing - Invoicing - Edit',

    PurchasingQuotingView = 'Purchasing - Quoting - View',
    PurchasingQuotingEdit = 'Purchasing - Quoting - Edit',

    PurchasingReconciliationView = 'Purchasing - Reconciliation - View',
    PurchasingReconciliationEdit = 'Purchasing - Reconciliation - Edit',

    PurchasingMaterialsView = 'Purchasing - Materials - View',
    PurchasingMaterialsEdit = 'Purchasing - Materials - Edit',

    FabBoardView = 'Fab - Board - View',
    FabBoardEdit = 'Fab - Board - Edit',
    FabSetupView = 'Fab - Setup - View',
    FabSetupEdit = 'Fab - Setup - Edit',
    FabDraftingQueueView = 'Fab - Drafting Queue - View',
    FabDraftingQueueEdit = 'Fab - Drafting Queue - Edit',
    FabShopFloorView = 'Fab - Shop Floor - View',
    FabShopFloorEdit = 'Fab - Shop Floor - Edit',
    FabDeliveryLookaheadView = 'Fab - Delivery Lookahead - View',
    FabHoldsView = 'Fab - Holds - View',
    FabHoldsEdit = 'Fab - Holds - Edit',

    FieldToolsSwpppView = 'Field Tools - SWPPP - View',
    FieldToolsSwpppEdit = 'Field Tools - SWPPP - Edit',
    FieldToolsSwpppDashboardView = 'Field Tools - SWPPP Dashboard - View',
}
